const state = {
    list: [
        { value: 'Фізична Особа', id: 0, key: 'natural' },
        { value: 'ФОП', id: 1, key: 'legal' },
        { value: 'ТОВ', id: 2, key: 'tov' },
        { value: 'Фізична Особа реферальна', id: 4, key: 'natural-referal' },
    ],
};

const getters = {
    USER_RECIPIENT_TYPES: state => state.list
};

export default {
    state,
    getters
};
